import { isValidUrl } from "../../../../utils/commonValidation";
import { findWebhookConfigurationByType } from "../../../../features/webhooks/webhook.selectors";
import { WEBHOOK_EVENT_CATEGORY } from "../../../../constants/strings";

export const getWebhookConfigByType = (map, type) => map?.[type] ?? null;

export const getMergedWebhookConfig = (config, dirtyConfig) => ({
  ...(config || {}),
  ...(dirtyConfig || {}),
});

const hasWebhookConfigurationChanges = (config = {}, dirtyConfig = {}) => {
  const mergedConfig = getMergedWebhookConfig(config, dirtyConfig);

  return JSON.stringify(config) !== JSON.stringify(mergedConfig);
};

const isWebhookConfigurationSaveable = (config) => {
  const { webhookIsEnabled, url, secrets } = config || {};

  if (!webhookIsEnabled) {
    return true;
  }

  const urlTrimmed = url != null ? String(url).trim() : "";

  return (
    Boolean(urlTrimmed) &&
    isValidUrl(urlTrimmed) &&
    Array.isArray(secrets) &&
    secrets.length > 0
  );
};

export const hasUnsavedWebhookChanges = (config, dirtyConfig) => {
  const mergedConfig = getMergedWebhookConfig(config, dirtyConfig);

  return (
    hasWebhookConfigurationChanges(config, dirtyConfig) &&
    isWebhookConfigurationSaveable(mergedConfig)
  );
};

export const hasDirtyWebhookConfiguration = (config, dirtyConfig) => {
  if (!dirtyConfig || Object.keys(dirtyConfig).length === 0) {
    return false;
  }
  if (!config?.webhookConfiguration?.length) {
    return false;
  }
  return config.webhookConfiguration.some((webhookTypeConfig) => {
    const { type } = webhookTypeConfig;
    const dirtyConfigForType = getWebhookConfigByType(dirtyConfig, type);
    if (!dirtyConfigForType) {
      return false;
    }

    return hasWebhookConfigurationChanges(
      findWebhookConfigurationByType(config, type),
      dirtyConfigForType
    );
  });
};

export const isAllGroup = (key) => key?.toString().toUpperCase() === "ALL";

const isWebhookItemEnabled = (item) =>
  item?.webhookEnabled ?? item?.webhookIsEnabled;

export const getEnabledNotificationTypeCodes = (notifications) =>
  Object.values(notifications)
    .flat()
    .filter(isWebhookItemEnabled)
    .map((item) => item?.code)
    .filter(Boolean);

export const getEnabledEventTypeCodes = (events) =>
  Object.entries(events).flatMap(([category, items]) => {
    return items
      .filter(isWebhookItemEnabled)
      .map((item) => (item.code || item.group || "").toString().toUpperCase())
      .filter(Boolean)
      .map((group) => `${WEBHOOK_EVENT_CATEGORY[category]}_${group}`);
  });
